import React from "react"

import { MarkovStateFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchMarkovState {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: MarkovStateFilters
    onFilter: (filters: MarkovStateFilters) => void
}

const MarkovStateSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchMarkovState) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default MarkovStateSearch
